import {ProDrawer, ProDrawerProps} from '../../../../../Components/ProDrawer';
import styles from './index.module.scss';
import {Button, Table, TableColumnsType} from 'antd';
import useRequest from '../../../../../Utils/Hooks/useRequest';
import {ActionItem, deleteAction, listAction, MenuItem} from '../../service';
import {PlusOutlined} from '@ant-design/icons';
import useModalHandler from '../../../../../Utils/Hooks/useModalHandler';
import {ActionEditDrawer} from '../ActionEditDrawer';
import {useDict} from '../../useDict';
import {Auth} from '../../../../../Features/Auth';
import ProTable from '../../../../../Components/ProTable';
import {LinkButton} from '../../../../../Features/Buttons/LinkButton';
import {useConfirmDelete} from '../../../../../Utils/Hooks/useConfirmDelete';

interface ActionDrawerProps extends ProDrawerProps {
    menu: MenuItem;
}

export function ActionDrawer({menu, ...props}: ActionDrawerProps) {
    const dict = useDict();

    const actionEditDrawer = useModalHandler({
        component: ActionEditDrawer,
        type: 'drawer',
    });

    const [data, {loading}, refresh] = useRequest(() => listAction(menu.id));

    const onDelete = useConfirmDelete(async (id: string) => {
        await deleteAction(id);
        refresh();
    });

    function onSaveOk() {
        refresh();
        actionEditDrawer.close();
    }

    const columns: TableColumnsType<ActionItem> = [
        {
            title: '操作项名称',
            dataIndex: 'name',
        },
        {
            title: '编码',
            dataIndex: 'code',
        },
        {
            title: '请求路径',
            dataIndex: 'url',
        },
        {
            title: '操作',
            width: 120,
            align: 'center',
            render: (_, item) => (
                <ProTable.Operate>
                    <LinkButton
                        onClick={() =>
                            actionEditDrawer.open({
                                initData: item,
                                parentId: item.parentId,
                                onOk: onSaveOk,
                            })
                        }>
                        编辑
                    </LinkButton>

                    <LinkButton onClick={() => onDelete(item.id)}>
                        删除
                    </LinkButton>
                </ProTable.Operate>
            ),
        },
    ];

    return (
        <ProDrawer {...props} title="操作项设置" width={1000}>
            <div className={styles.info}>
                <p>菜单类型: {dict.MenuType.getName(menu.levelType)}</p>
                <p>菜单名称: {menu.name}</p>
                <p>菜单编码: {menu.code}</p>
            </div>

            <Table
                rowKey="code"
                columns={columns}
                dataSource={data || []}
                loading={loading}
                pagination={false}
                scroll={{y: 600}}
                expandable={{
                    showExpandColumn: false,
                }}
            />

            <Auth code="SF_GRglhO4j09">
                <Button
                    className={styles.button}
                    type="dashed"
                    block
                    onClick={() =>
                        actionEditDrawer.open({
                            parentId: menu.id,
                            onOk: onSaveOk,
                        })
                    }>
                    <PlusOutlined /> 添加操作项
                </Button>
            </Auth>

            {actionEditDrawer.render()}
        </ProDrawer>
    );
}
